import styled from "styled-components";
import LoginIllustration from '../../login/assets/images/login.png'

export const LoginWrapper = styled.div`
    display: flex;
    flex-direction: column;
    //justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: #016EEB;
    background-image: url(${LoginIllustration});
    background-size: cover;
`;

export const LoginDialogWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    overflow: hidden;
`;

export const LoginFormWrapper = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: column; 
    align-items: stretch;
    height: 100%;
`;

export const TitleForm = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    box-sizing: border-box;
    height: 200px;
    width: 350px;
    margin: 0px ; 
`;

export const LoginFormTitle = styled.div`
    margin-top: 80px;
    margin-bottom: 0px;
    font-size: 35px;
    font-weight: bold;
    color: #f8f6f6;
    text-align: center;
`;

export const LoginFormTitleEn = styled.div`
    margin-top: 20px;
    margin-bottom: 40px;
    font-size: 25px;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
`;

export const LoginForm = styled.div`
    flex: 0 0 auto; 
    display: flex;
    flex-direction: column;
    align-items: stretch;
    box-sizing: border-box;
    width: 100%;
    padding: 30px;
    margin-top: 30px;
    border-radius: 10px;
    background-color: #FFFFFF;
`;

export const FormItemWrapper = styled.div`
    margin-top: 0px;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    padding: 10px 0px;
`;

export const ErrorMessage = styled.div`
    height: 20px;
    color: #EE0000;
`;

export const FormItemLabel = styled.div`
    margin-left: 10px;
    font-size: 14px;
    letter-spacing: 2px;
    color: #333333;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const FormItemInput = styled.input`
    box-sizing: border-box;
    padding: 0px 20px;
    height: 50px;
    margin-top: 20px;
    border: 1px solid #BBBBBB;
    border-radius: 5px;
    color: #101010;
    font-size: 17px;
    letter-spacing: 1px;
    width: 100%;
`;

export const FormSubmit = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    height: 50px;
    margin-top: 10px;
    border: none;
    border-radius: 5px;
    font-size: 20px;
    letter-spacing: 10px;
    text-align: center;
    color: #FFFFFF;
    background-color: #016EEB;

    &:hover {
        background-color: #0077FF;
    }
`;

export const LoginPicture = styled.div`
    flex: 1 1 auto;
    background-image: url(${LoginIllustration});
    background-size: cover;
    background-position: center center;
`;
